/* unplugin-vue-components disabled */import script from "./previewfile.vue?vue&type=script&setup=true&lang=js"
export * from "./previewfile.vue?vue&type=script&setup=true&lang=js"

import "./previewfile.vue?vue&type=style&index=0&id=0f54f043&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f54f043"]])

export default __exports__